/* import __COLOCATED_TEMPLATE__ from './status-cell-wrapper.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();